import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const cloningOptions = {
  element: 'div.signature-card--actions > div > ul',
  popover: {
    title: $format('label.TOURS.STUDIO.CLONE.OPTIONS.TITLE'),
    description: $format('label.TOURS.STUDIO.CLONE.OPTIONS.DESCRIPTION'),
    side: 'right',
    align: 'start',
    onNextClick: () => {
      const cloneToDomain = document.querySelector('[data-testid="sig-action-clone-domain"]');

      if (cloneToDomain) {
        cloneToDomain.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.moveNext();
        }, 160);
      } else {
        GLOBAL_DRIVER_OBJECT.moveTo(4);
      }
    }
  }
};
